import { Navigate, useLocation } from "react-router-dom";
import AccessDenied from "../pages/errorpages/AccessDenied";
import { getStoredUser, hasAnyRole } from "../utilities/userAccess";

const ProtectedRoute = ({ children, allowedRoles, canAccess, skipRoleCheck = false }) => {
  const location = useLocation();
  const token = localStorage.getItem("token");
  const user = getStoredUser();

  if (!token || !user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  const profileIncomplete =
    !String(user.mobile_number ?? "").trim() || !String(user.voter_id ?? "").trim();
  if (
    profileIncomplete &&
    !["/profile", "/logout"].includes(location.pathname)
  ) {
    return <Navigate to="/profile" replace />;
  }

  if (canAccess && !canAccess(user)) {
    return <AccessDenied />;
  }

  if (skipRoleCheck || !allowedRoles || allowedRoles.length === 0) {
    return children;
  }

  if (!hasAnyRole(user, allowedRoles)) {
    return <AccessDenied />;
  }

  return children;
};

export default ProtectedRoute;
